import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../../style.scss";

function ListIntegration(props) {
  const [integrations, setIntegrations] = useState([]);
  const [expandedId, setExpandedId] = useState(null);
  const [visibleKeys, setVisibleKeys] = useState({});
  const [copiedId, setCopiedId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchResponse = await axios({
          method: "GET",
          url: props.chimeraserv.urlQlub + "/outlet-api-key/type/QLUBPAT",
          headers: {
            "x-auth-key": props.chimeraserv.qlubAuthKey,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        setIntegrations(fetchResponse.data || []);
      } catch (error) {
        setIntegrations([]);
      }
    };
    fetchData();
  }, [props.chimeraserv.urlQlub]);

  const toggleView = (integrationId) => {
    setExpandedId(expandedId === integrationId ? null : integrationId);
  };

  const toggleKeyVisibility = (integrationId) => {
    setVisibleKeys((prev) => ({
      ...prev,
      [integrationId]: !prev[integrationId],
    }));
  };

  const maskApiKey = (key) => {
    if (!key) return "";
    if (key.length <= 4) return "••••";
    return "•".repeat(Math.max(key.length - 4, 8)) + key.slice(-4);
  };

  const copyApiKey = async (key, integrationId) => {
    try {
      await navigator.clipboard.writeText(key || "");
      setCopiedId(integrationId);
      setTimeout(() => setCopiedId(null), 1500);
    } catch (error) {
      alert("Failed to copy API key to clipboard");
    }
  };

  const toggleStatus = async (integration) => {
    const newStatus = integration.status === "active" ? "inactive" : "active";
    try {
      const response = await axios({
        method: "PATCH",
        url: `${props.chimeraserv.urlQlub}/outlet-api-key/${integration.outletId}/status`,
        headers: {
          "x-auth-key": props.chimeraserv.qlubAuthKey,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: { status: newStatus },
      });

      setIntegrations((prev) =>
        prev.map((item) =>
          item._id === integration._id
            ? { ...item, status: response.data.record?.status ?? newStatus }
            : item
        )
      );
    } catch (error) {
      alert("Failed to update status. Please try again.");
    }
  };

  const calculateRemainingDays = (expiryDate) => {
    if (!expiryDate) return null;

    const currentDate = new Date();
    const expiry = new Date(expiryDate);
    const remainingDays = Math.floor(
      (expiry - currentDate) / (1000 * 60 * 60 * 24)
    );

    return remainingDays;
  };

  return (
    <div className="integration-list-page">
      <h2 className="viewTitle">Integrations</h2>
      <div className="integration-grid">
        {integrations.length > 0 ? (
          integrations.map((integration) => (
            <div className="integration-card" key={integration._id}>
              <div className="integration-header">
                <span className="integration-name">{integration.outletId}</span>
                {props.user.data.level === 0 && (
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={integration.status === "active"}
                      onChange={() => toggleStatus(integration)}
                    />
                    <span className="slider"></span>
                  </label>
                )}
              </div>

              {expandedId === integration._id && (
                <div
                  className="integration-details"
                  style={{
                    marginTop: "15px",
                    padding: "15px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "4px",
                    border: "1px solid #dee2e6",
                  }}
                >
                  <div style={{ marginBottom: "10px" }}>
                    <strong>Outlet ID:</strong> {integration.outletId}
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    <strong>API Key:</strong>
                    <span
                      style={{
                        wordBreak: "break-all",
                        fontFamily: "monospace",
                        fontSize: "0.9em",
                        marginLeft: "5px",
                      }}
                    >
                      {visibleKeys[integration._id]
                        ? integration.apiKey
                        : maskApiKey(integration.apiKey)}
                    </span>
                    <button
                      type="button"
                      onClick={() => toggleKeyVisibility(integration._id)}
                      className="action-btn"
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "0 6px",
                        color: "inherit",
                      }}
                      title={
                        visibleKeys[integration._id]
                          ? "Hide API Key"
                          : "Show API Key"
                      }
                    >
                      <FontAwesomeIcon
                        icon={[
                          "fas",
                          visibleKeys[integration._id] ? "eye-slash" : "eye",
                        ]}
                      />
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        copyApiKey(integration.apiKey, integration._id)
                      }
                      className="action-btn"
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "0 6px",
                        color: "inherit",
                      }}
                      title="Copy API Key"
                    >
                      <FontAwesomeIcon
                        icon={[
                          "fas",
                          copiedId === integration._id ? "check" : "copy",
                        ]}
                      />
                    </button>
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    <strong>Status:</strong>{" "}
                    <span
                      style={{
                        color:
                          integration.status === "active"
                            ? "#28a745"
                            : "#dc3545",
                        fontWeight: "bold",
                      }}
                    >
                      {integration.status || "N/A"}
                    </span>
                  </div>
                  {integration.expiryDate && (
                    <>
                      <div style={{ marginBottom: "10px" }}>
                        <strong>Expiry Date:</strong>{" "}
                        {new Date(integration.expiryDate).toLocaleString()}
                      </div>
                      <div style={{ marginBottom: "10px" }}>
                        <strong>Remaining Days:</strong>{" "}
                        <span
                          style={{
                            color:
                              calculateRemainingDays(integration.expiryDate) >
                              30
                                ? "#28a745"
                                : calculateRemainingDays(
                                      integration.expiryDate
                                    ) > 0
                                  ? "#ffc107"
                                  : "#dc3545",
                            fontWeight: "bold",
                          }}
                        >
                          {calculateRemainingDays(integration.expiryDate)} days
                          {calculateRemainingDays(integration.expiryDate) <=
                            0 && " (Expired)"}
                        </span>
                      </div>
                    </>
                  )}
                  {integration.createdAt && (
                    <div style={{ marginBottom: "10px" }}>
                      <strong>Created:</strong>{" "}
                      {new Date(integration.createdAt).toLocaleString()}
                    </div>
                  )}
                  {integration.updatedAt && (
                    <div>
                      <strong>Updated:</strong>{" "}
                      {new Date(integration.updatedAt).toLocaleString()}
                    </div>
                  )}
                </div>
              )}

              <div className="integration-actions">
                {props.user.data.level === 0 && (
                  <Link
                    to={`/app/integrations/edit/${integration._id}`}
                    state={{ data: integration }}
                    className="action-btn"
                  >
                    <FontAwesomeIcon icon={["fas", "cog"]} /> Edit
                  </Link>
                )}
                <button
                  onClick={() => toggleView(integration._id)}
                  className="action-btn"
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "0",
                    color: "inherit",
                  }}
                >
                  <FontAwesomeIcon
                    icon={[
                      "fas",
                      expandedId === integration._id ? "eye-slash" : "eye",
                    ]}
                  />
                  {expandedId === integration._id ? " Hide" : " View"}
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="no-integrations">No integrations found.</div>
        )}
      </div>
    </div>
  );
}

export default ListIntegration;
